/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Stats sub-tab — rolled-up totals + top reasons + recent activity.
 * Read-only; mirrors the `/banstats` Discord command.
 */
import { Shield, Ban, Bot, Eye, MessageSquare } from "lucide-react";

export default function StatsTab({ stats }) {
  if (!stats) {
    return <div className="glass-card p-6 text-sm text-[var(--muted)]">Loading stats…</div>;
  }
  const cards = [
    { label: "Active Bans",     value: stats.active,          icon: Ban,        tint: "rose" },
    { label: "Total Bans",      value: stats.total,           icon: Shield,     tint: "teal" },
    { label: "Auto-Bans",       value: stats.auto_bans,       icon: Bot,        tint: "amber" },
    { label: "Manual Bans",     value: stats.manual_bans,     icon: Shield,     tint: "teal" },
    { label: "Watchlist",       value: stats.watchlist,       icon: Eye,        tint: "teal" },
    { label: "Pending Appeals", value: stats.pending_appeals, icon: MessageSquare, tint: "rose" },
  ];
  return (
    <div className="space-y-4">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="moderation-stats-grid">
        {cards.map((c) => (
          <div key={c.label} className="glass-card p-4">
            <div className="flex items-center justify-between mb-1">
              <span className="text-[10px] uppercase tracking-[0.18em] text-[var(--muted)]">{c.label}</span>
              <c.icon size={14} className="text-[var(--muted)]" />
            </div>
            <div className="font-mono text-3xl text-[var(--bone)]">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="glass-card p-4">
          <h3 className="label mb-3">Top Ban Reasons</h3>
          {stats.top_reasons.length === 0 ? (
            <p className="text-[var(--muted)] text-sm">No bans yet.</p>
          ) : (
            <ul className="space-y-1.5">
              {stats.top_reasons.map((r, i) => (
                <li key={i} className="flex justify-between text-sm">
                  <span className="text-[var(--bone)] truncate">{r.reason}</span>
                  <span className="font-mono text-[var(--teal)]">{r.n}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="glass-card p-4">
          <h3 className="label mb-3">Recent Activity</h3>
          {stats.recent.length === 0 ? (
            <p className="text-[var(--muted)] text-sm">No recent bans.</p>
          ) : (
            <ul className="space-y-1.5 text-xs font-mono">
              {stats.recent.map((b, i) => (
                <li key={i} className="flex justify-between gap-2">
                  <span className="truncate text-[var(--bone)]" title={b.player_id}>
                    {b.player_name || b.player_id}
                  </span>
                  <span className="text-[var(--muted)]">{b.server || "—"}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
